<template>
    <div class="bulma">
        <div
            class="modal is-active"
            v-if="chatCreateModalIsShown"
        >
            <div class="modal-background" @click="closeModal"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">
                        {{ trans.modal_title.creation }}
                    </p>
                    <a
                        @click="closeModal"
                        :title="trans.buttons.close"
                    >
                        <svg>
                            <use xlink:href="#icon-cross"></use>
                        </svg>
                    </a>
                </header>
                <section class="modal-card-body">
                    <div v-html="modalCardBodyText" />
                </section>
                <footer class="modal-card-foot">
                    <button
                        v-if="!isCreateButtonRendered"
                        @click="create"
                        :disabled="isRequestInProgress"
                        :class="{'is-loading': isRequestInProgress}"
                        class="button is-info"
                    >
                        {{ trans.buttons.create }}
                    </button>
                    <button
                        @click="closeModal"
                        :disabled="isRequestInProgress"
                        class="button"
                    >
                        {{ closeButtonText }}
                    </button>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
    name: "ChatCreateModal",
    props: {
        initActions: Object,
        initTrans: Object,
    },
    mounted() {
        this.setActions(this.initActions);
        this.setTrans(this.initTrans);
    },
    computed: {
        ...mapGetters('bx24Chat', [
            'trans',
            'chatCreateModalIsShown',
            'isRequestInProgress',
            'isRequestSuccessfull',
            'isRequestErrored',
            'portalChatLink',
        ]),
        ...mapGetters('baseDocumentData', [
            'documentHash',
            'documentName',
        ]),
        modalCardBodyText() {
            let createdMessage = this.replaceWildcards(this.trans.modal_card.chat_successfully_created, {
                url: this.portalChatLink,
            });

            if (this.isRequestErrored) {
                return this.trans.error;
            }

            let creatingMessage = this.replaceWildcards(this.trans.modal_card.chat_creating_message, {
                documentName: this.documentName,
            });

            return this.isRequestSuccessfull ? createdMessage : creatingMessage;
        },
        closeButtonText() {
            let transButton;

            this.isRequestSuccessfull || this.isRequestErrored
                ? transButton = this.trans.buttons.close
                : transButton = this.trans.buttons.cancel;

            return transButton;
        },
        isCreateButtonRendered() {
            return this.isRequestSuccessfull || this.isRequestErrored;
        },
    },
    methods: {
        ...mapActions('bx24Chat', [
            'setActions',
            'setTrans',
            'hideChatCreateModal',
            'createChat',
            'unsetIsRequestSuccessfull',
            'unsetIsRequestErrored',
        ]),
        closeModal() {
            this.hideChatCreateModal();
            this.unsetIsRequestSuccessfull();
            this.unsetIsRequestErrored();
        },
        create() {
            this.createChat(this.documentHash);
        },
    },
}
</script>

<style lang="scss" scoped>
    @import 'resources/sass/variables.scss';

    svg {
        width: 16px;
        height: 16px;
        fill: $white;
        &:hover {
            fill: $black;
        }
    }
</style>
